<template>
  <q-page padding>
    <div class="row col-12 justify-between align-center">
      <p class="text-h6 text-brand-1 text-weight-bolder">Fluxo Completo</p>
    </div>

    <div
      v-if="
        $store.state.autenticacao.cliente.includes('staging-vale') ||
        $store.state.autenticacao.cliente.includes('vale-epiexpress')
      "
      class="row col-12 text-brand-5 text-weight-bold q-mt-lg"
    >
      <div class="row col-12 container-video q-gutter-sm">
        <div class="row col-12 items-center texto-link">
          <a
            href="https://sites.google.com/multpex.com.br/basedeconhecimento/d%C3%BAvidas-administrativas/download-e-instala%C3%A7%C3%A3o-leitor-biom%C3%A9trico-web"
            target="_blank"
          >
            <q-icon class="q-mr-xs" name="link" size="22px" />Procedimento de
            Configuração e Utilização do Leitor Biométrico</a
          >
        </div>
        <div class="row justify-center">
          <div class="col-md">
            <q-video
              src="https://www.youtube.com/embed/oX-NzE34JEU?si=o0thKOfuUz9SCjVB"
              class="video"
            />
            <div class="row col-12 justify-center texto-link-legenda">
              Configuração do Leitor
            </div>
          </div>
          <div class="col-md q-ml-xl sem-margin">
            <q-video
              src="https://www.youtube.com/embed/ZeNPIZtbTj4?si=mVcNkcQXy4H3nVRn"
              class="video"
            />
            <div class="row col-12 justify-center texto-link-legenda">
              Funcionamento Fluxo Completo
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="row col-12 text-weight-bold text-brand-5 q-mt-md q-gutter-sm container-inputs"
    >
      <div class="col-md-2 col-sm-5 col-xs-5">
        <div class="texto-titulo-input">Unidade</div>
        <lista-unidades-select
          class="input-new-design"
          v-model="unidade.nome"
        ></lista-unidades-select>
      </div>
      <div class="col-md-2 col-sm-6 col-xs-6">
        <div class="texto-titulo-input">Contrato</div>
        <q-input
          v-model="dados.contrato.label"
          dense
          outlined
          bg-color="brand-7"
          class="select input-new-design"
          disable
        />
      </div>
      <div v-if="temPermissaoCracha()" class="col-md col-xs-4">
        <div class="texto-titulo-select">Crachá Solicitante</div>
        <SelecaoFuncionario
          class="input-new-design"
          dense
          outlined
          v-model="crachaSolicitante"
          @emitirFuncionario="receberFuncionarioPorCracha"
          debounce="500"
          :buscarPorCracha="true"
        />
      </div>
      <div class="col-md-2 col-sm-6 col-xs-6">
        <div class="texto-titulo-input">Solicitante</div>
        <SelecaoFuncionario
          class="input-new-design"
          @emitirFuncionario="receberFuncionario"
          :atualizarDados="atualizarUsuario"
          :disable="autenticacao"
        />
      </div>
      <div class="col-md-2 col-sm-6 col-xs-6">
        <div class="texto-titulo-input">Centro de Custo</div>

        <q-input
          v-model="centroCustoUsuario"
          dense
          outlined
          bg-color="brand-7"
          class="select input-new-design"
          disable
        />
      </div>
      <div class="col-md-2 col-sm-6 col-xs-6">
        <div class="texto-titulo-input">Saldo Estoque</div>
        <q-select
          v-model="saldo"
          dense
          outlined
          map-options
          emit-value
          option-value="value"
          option-label="label"
          :options="saldoOptionsFiltered"
          :disable="isSaldoSelectDisabled"
          :bg-color="isSaldoSelectDisabled ? 'brand-7' : undefined"
          class="select input-new-design"
        />
      </div>
    </div>

    <div
      class="row q-mt-xl col-12 text-brand-5 text-weight-regular container-radio"
    >
      <div
        style="font-weight: 100; font-size: 16px"
        class="text-weight-bold text-brand-1 titulo-input-tipo-requisicao"
      >
        Selecione a condição dos produtos que serão listados
      </div>

      <div class="q-ml-sm col-12 q-mt-sm radio-input-tipo">
        <q-radio
          :size="mobile ? 'sm' : 'lg'"
          val="all"
          label="Todos"
          :model-value="filtros.tipoRequisicao"
          @click="interceptarMudancaTipoRequisicao('all')"
          :disable="
            (!dados.usuario && !crachaSolicitante) ||
            autenticacao ||
            $store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles.indexOf(
              'voucher-produto-todos'
            ) != -1
          "
        >
        </q-radio>

        <q-radio
          val="liberados"
          label="Produtos Liberados"
          :model-value="filtros.tipoRequisicao"
          @click="interceptarMudancaTipoRequisicao('liberados')"
          :size="mobile ? 'sm' : 'lg'"
          :disable="
            (!dados.usuario && !crachaSolicitante) ||
            autenticacao ||
            $store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles.indexOf(
              'voucher-produto-liberados'
            ) != -1
          "
        >
        </q-radio>
        <q-radio
          :size="mobile ? 'sm' : 'lg'"
          val="yes"
          label="Todos EPI"
          :model-value="filtros.tipoRequisicao"
          @click="interceptarMudancaTipoRequisicao('yes')"
          :disable="
            (!dados.usuario && !crachaSolicitante) ||
            autenticacao ||
            $store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles.indexOf(
              'voucher-produto-epis'
            ) != -1
          "
        >
        </q-radio>
      </div>
    </div>
    <div class="col-12 q-mt-xl mobile">
      <div
        class="row justify-between text-h6 container-texto-input-search text-brand-5 text-weight-bold q-mt-lg q-mb-lg"
      >
        <span class="q-mb-md texto-titulo-tabela"
          >Selecione os Produtos para Requisição</span
        >

        <div class="input-search-table col-md-3 col-xs-12">
          <q-input
            rounded
            outlined
            dense
            debounce="300"
            v-model="filtros.produto"
            type="text"
            class="col-xs-12 col-sm-12"
            placeholder="Pesquisar Produto"
            :disable="autenticacao || filtros.tipoRequisicao === ''"
          >
            <template v-slot:append>
              <q-icon name="search" />
            </template>
          </q-input>
        </div>
      </div>
      <div>
        <q-table
          grid
          :rows="listaProdutos"
          color="primary"
          dense
          :columns="columns"
          selection="multiple"
          row-key="code"
          flat
          hide-pagination
          :loading="loading"
          hide-bottom
          v-model:selected="selected"
          :rows-per-page-options="[8]"
        >
          <template v-slot:item="props">
            <div class="q-pa-xs col-xs-12 col-sm-6 col-md-4">
              <div class="row card">
                <div class="col-3 q-mr-sm text-center q-mt-md">
                  <div
                    v-if="props.row.product_images.length != 0"
                    class="img-container-grid q-ml-sm"
                  >
                    <q-img
                      v-if="props.row.product_images.length != 0"
                      :src="props.row.product_images[0].url"
                      fit="contain"
                      class="img-grid"
                    />
                  </div>
                  <div class="img-container-grid q-ml-sm" v-else>
                    <span class="img-grid"></span>
                  </div>
                </div>
                <div class="col">
                  <q-card-section class="row text-brand-5 text-grid-table">
                    <div class="col-12" style="margin-bottom: 3px">
                      <span><strong>Código:</strong> {{ props.row.code }}</span>
                      <span class="q-mr-sm"
                        ><strong>Nome:</strong>
                        {{
                          props.row?.pivot &&
                          props.row?.pivot.contract_product_description
                            ? props.row?.pivot.contract_product_description
                            : props.row?.name
                        }}</span
                      >
                    </div>
                    <div class="col-12" style="margin-bottom: 3px">
                      <span>
                        <strong>CA:</strong>
                        <span
                          v-if="
                            props.row.ca_codigo &&
                            props.row.ca_codigo.toString().trim() !== ''
                          "
                          class="ca-link"
                          @click="
                            validarCa(
                              props.row.ca_codigo,
                              props.row.pivot?.ca?.id
                            )
                          "
                          style="
                            color: #1976d2;
                            cursor: pointer;
                            text-decoration: underline;
                          "
                        >
                          {{ props.row.ca_codigo }}
                        </span>
                        <span v-else>-</span>
                      </span>
                    </div>
                    <div class="col-12" style="margin-bottom: 3px">
                      <span
                        ><strong>Estoque:</strong>
                        {{
                          parseInt(props.row.stock[0].pivot.amount).toFixed(2)
                        }}</span
                      >
                    </div>
                    <div class="col-12" style="margin-bottom: 3px">
                      <span
                        ><strong>Grupo de Produto</strong>
                        {{ props.row?.pivot?.product_group?.name }}
                      </span>
                    </div>
                    <div class="col-12">
                      <div class="col-12">
                        <div class="text-brand-5 btn-grid-container">
                          <div class="row col-12 items-center">
                            <div class="q-mr-sm">
                              <p></p>
                              <q-icon
                                class="arrow"
                                name="arrow_left"
                                style="background: #6391f4"
                                @click="
                                  !autenticacao
                                    ? props.row.quantidade != null &&
                                      props.row.quantidade > 0
                                      ? props.row.quantidade--
                                      : ''
                                    : ''
                                "
                              />
                            </div>
                            <div
                              class="row col-2 justify-center input-quantidade-container"
                              style="border-bottom: 1px solid #505050"
                            >
                              <q-input
                                class="input-quantidade"
                                borderless
                                dense
                                type="number"
                                v-model="props.row.quantidade"
                                :disable="autenticacao"
                                min="0"
                              />
                            </div>
                            <div class="q-ml-sm">
                              <p></p>
                              <q-icon
                                name="arrow_right"
                                class="arrow"
                                style="background: #6391f4"
                                @click="
                                  !autenticacao
                                    ? props.row.quantidade == null
                                      ? (props.row.quantidade = 1)
                                      : props.row.quantidade++
                                    : ''
                                "
                              />
                            </div>
                            <div class="q-ml-md">
                              <p></p>
                              <q-btn
                                :icon="props.selected ? 'close' : 'add'"
                                :color="props.selected ? 'red' : 'secondary'"
                                label="Selecionar"
                                @click="props.selected = !props.selected"
                                :disable="props.selected"
                                no-caps
                                dense
                                size="11px"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </q-card-section>
                </div>
              </div>
            </div>
          </template>
        </q-table>
      </div>
    </div>
    <div class="col-12 q-mt-xl desktop">
      <div
        class="row justify-between text-h6 container-texto-input-search text-brand-5 text-weight-bold q-mt-lg q-mb-lg"
      ></div>
      <q-linear-progress size="xs" v-if="loading" indeterminate />
      <div>
        <q-table
          :grid="$q.screen.lt.sm"
          :rows="listaProdutos"
          color="primary"
          :columns="columns"
          selection="multiple"
          dense
          row-key="code"
          class="my-sticky-dynamic"
          flat
          hide-pagination
          v-model:selected="selected"
          :rows-per-page-options="[0]"
        >
          <template v-slot:top-left>
            <span
              style="
                font-size: 16px;
                display: block;
                margin-left: -15px;
                color: #21324a;
              "
              >Selecione os Produtos para Requisição
            </span>
          </template>
          <template v-slot:top-right>
            <div class="row q-gutter-sm">
              <div>
                <q-input
                  rounded
                  outlined
                  dense
                  debounce="300"
                  v-model="filtros.produto"
                  type="text"
                  class="col-xs-12 col-sm-12"
                  placeholder="Pesquisar Produto"
                  :disable="autenticacao || filtros.tipoRequisicao === ''"
                >
                  <template v-slot:append>
                    <q-icon name="search" />
                  </template>
                </q-input>
              </div>
              <div v-if="temPermissaoBuscaCA()">
                <q-input
                  rounded
                  outlined
                  dense
                  debounce="300"
                  v-model="filtros.caCodigo"
                  type="text"
                  placeholder="Código CA"
                  :disable="autenticacao || filtros.tipoRequisicao === ''"
                >
                  <template v-slot:append>
                    <q-icon name="badge" />
                  </template>
                </q-input>
              </div>
              <div v-if="temPermissaoBuscaCA()">
                <q-select
                  rounded
                  outlined
                  dense
                  v-model="filtros.caStatus"
                  option-value="value"
                  option-label="label"
                  :options="[
                    { label: 'Todos', value: '' },
                    { label: 'Válido', value: 'Válido' },
                    { label: 'Vencido', value: 'Vencido' },
                  ]"
                  label="Status CA"
                  style="min-width: 240px"
                  :disable="autenticacao || filtros.tipoRequisicao === ''"
                >
                  <template v-slot:append>
                    <q-icon name="verified" />
                  </template>
                </q-select>
              </div>
            </div>
          </template>
          <template v-slot:no-data="props">
            <div
              v-if="props"
              style="background-color: transparent"
              class="full-width row flex-center q-gutter-sm q-mt-sm"
            >
              <q-img
                src="./../../../assets/tabelSemDados.svg"
                style="height: 170px; width: 150px"
              />
            </div>
          </template>
          <template v-slot:item="props">
            <div class="q-pa-xs col-xs-12 col-sm-6 col-md-4">
              <div class="row card">
                <div class="col">
                  <q-card-section class="row">
                    <div class="col-12" style="margin-bottom: 3px">
                      <span><strong>Código:</strong> {{ props.row.code }}</span>
                    </div>
                    <div class="col-12" style="margin-bottom: 3px">
                      <span
                        ><strong>Descrição:</strong>
                        {{
                          props.row?.pivot &&
                          props.row?.pivot.contract_product_description
                            ? props.row?.pivot.contract_product_description
                            : props.row?.name
                        }}</span
                      >
                    </div>
                    <div class="col-12" style="margin-bottom: 3px">
                      <span
                        ><strong>Endereço:</strong>
                        {{ props.row.stock[0]?.pivot.address }}</span
                      >
                    </div>
                    <div class="col-12" style="margin-bottom: 3px">
                      <span
                        ><strong>Unidade de Medida</strong>
                        {{ props.row.stock[0]?.pivot.measurement_unit }}
                      </span>
                    </div>
                    <div class="col-12" style="margin-bottom: 3px">
                      <span>
                        <strong>CA:</strong>
                        <span
                          v-if="
                            props.row.ca_codigo &&
                            props.row.ca_codigo.toString().trim() !== ''
                          "
                          class="ca-link"
                          @click="
                            validarCa(
                              props.row.ca_codigo,
                              props.row.pivot?.ca?.id
                            )
                          "
                          style="
                            color: #1976d2;
                            cursor: pointer;
                            text-decoration: underline;
                          "
                        >
                          {{ props.row.ca_codigo }}
                        </span>
                        <span v-else>-</span>
                      </span>
                    </div>
                    <div class="col-12" style="margin-bottom: 3px">
                      <span
                        ><strong>Estoque</strong>
                        {{ props.row.stock[0]?.pivot.amount }}
                      </span>
                    </div>

                    <div class="col-12" style="margin-bottom: 3px">
                      <span
                        ><strong>Estoque Min.</strong>
                        {{ props.row.stock[0]?.pivot.minimal_amount }}
                      </span>
                    </div>
                    <div class="col-12">
                      <div class="col-12">
                        <div class="text-brand-5 btn-grid-container">
                          <div class="row col-12 items-center">
                            <div>
                              <p></p>
                              <q-btn
                                :icon="props.selected ? 'close' : 'add'"
                                :color="props.selected ? 'red' : 'secondary'"
                                label="Selecionar"
                                @click="
                                  $store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles.indexOf(
                                    'voucher-aviso-regra'
                                  ) == -1
                                    ? (props.selected = !props.selected)
                                    : filtros.tipoRequisicao == 'liberados'
                                    ? verificarQuantidade(props.row, props)
                                    : verificarQuantidadeHttp(
                                        props.row,
                                        props,
                                        (props.row.loadingButton = true)
                                      )
                                "
                                :disable="props.selected"
                                no-caps
                                dense
                                size="11px"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="col-12"
                      style="margin-bottom: 3px"
                      v-if="filtros.tipoRequisicao === 'liberados'"
                    >
                      <span>{{
                        compararData(props.row, props.row.pode_retirar)
                      }}</span>
                    </div>
                  </q-card-section>
                </div>
              </div>
            </div>
          </template>
          <template v-slot:header="props">
            <q-tr :props="props">
              <q-th v-for="col in props.cols" :key="col.name" :props="props">
                <span v-if="filtros.tipoRequisicao == 'liberados'">{{
                  col.label
                }}</span>
                <span v-else>{{
                  col.label == "Pode Retirar (S/N)" || col.label == "Critico"
                    ? ""
                    : col.label
                }}</span>
              </q-th>
            </q-tr>
          </template>
          <template v-slot:body="props">
            <q-tr>
              <q-td
                :style="{
                  'background-color':
                    props.row.critico == 1 && compararDataCritico(props.row)
                      ? '#FBA6B4'
                      : '',
                }"
              >
                <q-btn
                  class="q-ml-md"
                  :icon="props.selected ? 'close' : 'add'"
                  :color="props.selected ? 'red' : 'secondary'"
                  :disable="autenticacao"
                  :loading="props.row.loadingButton"
                  no-caps
                  round
                  dense
                  @click="
                    $store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles.indexOf(
                      'voucher-aviso-regra'
                    ) == -1
                      ? (props.selected = !props.selected)
                      : filtros.tipoRequisicao == 'liberados'
                      ? verificarQuantidade(props.row, props)
                      : verificarQuantidadeHttp(
                          props.row,
                          props,
                          (props.row.loadingButton = true)
                        )
                  "
                />
              </q-td>
              <q-td
                :style="{
                  'background-color':
                    props.row.critico == 1 && compararDataCritico(props.row)
                      ? '#FBA6B4'
                      : '',
                }"
              >
                <div
                  class="img-container"
                  style="width: 50px; height: 50px"
                  :class="{
                    'cursor-pointer':
                      props.row.product_images &&
                      props.row.product_images.length > 0,
                  }"
                  @click="
                    props.row.product_images &&
                      props.row.product_images.length > 0 &&
                      abrirImagemAmpliada(props.row.product_images[0].url)
                  "
                >
                  <q-img
                    v-if="
                      props.row.product_images &&
                      props.row.product_images.length > 0
                    "
                    :src="props.row.product_images[0].url"
                    fit="contain"
                    style="width: 100%; height: 100%"
                  />
                  <div
                    v-else
                    class="flex flex-center bg-grey-3"
                    style="width: 100%; height: 100%; border-radius: 4px"
                  >
                    <q-icon
                      name="image_not_supported"
                      size="sm"
                      color="grey-7"
                    />
                  </div>
                </div>
              </q-td>
              <q-td
                :style="{
                  'background-color':
                    props.row.critico == 1 && compararDataCritico(props.row)
                      ? '#FBA6B4'
                      : '',
                }"
              >
                <span>{{ props.row.code }}</span>
              </q-td>
              <q-td
                style="white-space: normal"
                :style="{
                  'background-color':
                    props.row.critico == 1 && compararDataCritico(props.row)
                      ? '#FBA6B4'
                      : '',
                }"
              >
                <span>{{
                  props.row?.pivot &&
                  props.row?.pivot.contract_product_description
                    ? props.row?.pivot.contract_product_description
                    : props.row?.name
                }}</span>
              </q-td>
              <q-td
                :style="{
                  'background-color':
                    props.row.critico == 1 && compararDataCritico(props.row)
                      ? '#FBA6B4'
                      : '',
                }"
              >
                <span>{{ props.row.stock[0]?.pivot.address }}</span>
              </q-td>
              <q-td
                :style="{
                  'background-color':
                    props.row.critico == 1 && compararDataCritico(props.row)
                      ? '#FBA6B4'
                      : '',
                }"
              >
                <span>{{ props.row.stock[0]?.pivot.measurement_unit }}</span>
              </q-td>
              <q-td
                :style="{
                  'background-color':
                    props.row.critico == 1 && compararDataCritico(props.row)
                      ? '#FBA6B4'
                      : '',
                }"
              >
                <span
                  v-if="
                    props.row.ca_codigo &&
                    props.row.ca_codigo.toString().trim() !== ''
                  "
                  class="ca-link"
                  @click="
                    validarCa(props.row.ca_codigo, props.row.pivot?.ca?.id)
                  "
                  style="
                    color: #1976d2;
                    cursor: pointer;
                    text-decoration: underline;
                  "
                >
                  {{ props.row.ca_codigo }}
                </span>
                <span v-else>-</span>
              </q-td>
              <q-td
                :style="{
                  'background-color':
                    props.row.critico == 1 && compararDataCritico(props.row)
                      ? '#FBA6B4'
                      : '',
                }"
              >
                <div v-if="props.row.ca_status || props.row.pivot?.ca?.status">
                  <div
                    v-if="
                      (props.row.ca_status || props.row.pivot?.ca?.status) ==
                      'Válido'
                    "
                    class="row align items-center"
                    style="
                      width: fit-content;
                      background: #e8ffec;
                      padding: 2px 5px;
                    "
                  >
                    <span class="elipse q-mr-sm bg-positive" />
                    <div
                      style="width: fit-content"
                      class="text-bold text-brand-5"
                    >
                      {{ props.row.ca_status || props.row.pivot?.ca?.status }}
                    </div>
                  </div>
                  <div
                    v-else
                    class="row align items-center"
                    style="
                      width: fit-content;
                      background: #ffe9e9;
                      padding: 2px 5px;
                    "
                  >
                    <span class="elipse q-mr-sm bg-red" />
                    <div
                      style="width: fit-content; color: #850202"
                      class="text-bold"
                    >
                      {{ props.row.ca_status || props.row.pivot?.ca?.status }}
                    </div>
                  </div>
                </div>
                <span v-else>-</span>
              </q-td>
              <q-td
                :style="{
                  'background-color':
                    props.row.critico == 1 && compararDataCritico(props.row)
                      ? '#FBA6B4'
                      : '',
                }"
              >
                <span v-if="props.row.critico == 1">Sim</span>
                <span v-if="props.row.critico == 0"> Não</span>
              </q-td>
              <q-td
                :style="{
                  'background-color':
                    props.row.critico == 1 && compararDataCritico(props.row)
                      ? '#FBA6B4'
                      : '',
                }"
              >
                <span>{{ props.row.stock[0]?.pivot.amount }}</span>
              </q-td>
              <q-td
                :style="{
                  'background-color':
                    props.row.critico == 1 && compararDataCritico(props.row)
                      ? '#FBA6B4'
                      : '',
                }"
              >
                <q-input
                  dense
                  outlined
                  type="number"
                  style="width: 60px"
                  v-model="props.row.quantidade"
                  :disable="autenticacao"
                  min="0"
                />
              </q-td>
              <q-td
                v-if="filtros.tipoRequisicao === 'liberados'"
                :style="{
                  'background-color':
                    props.row.critico == 1 && compararDataCritico(props.row)
                      ? '#FBA6B4'
                      : '',
                }"
              >
                <span>{{
                  compararData(props.row, props.row.pode_retirar)
                }}</span>
              </q-td>
            </q-tr>
            <q-tr
              :style="{
                'background-color':
                  props.row.critico == 1 && compararDataCritico(props.row)
                    ? '#FBA6B4'
                    : '',
              }"
              v-if="props.row.critico == 1 && compararDataCritico(props.row)"
              :props="props"
              :key="`e_${props.row.index}`"
              class="q-virtual-scroll--with-prev"
            >
              <q-td colspan="100%">
                <div class="text-left">
                  Atenção, a não retirada deste item está BLOQUEANDO a retirada
                  de todos os outros itens.
                </div>
              </q-td>
            </q-tr>
          </template>
        </q-table>
      </div>
    </div>
    <dialog-confirm
      mensagem="Esse produto ou quantidade está fora do prazo de entrega. Tem certeza que deseja continuar?"
      :exibir="aviso"
      :propsClass="'q-pa-md'"
      @resultado="adicionarLinha"
    >
    </dialog-confirm>
    <div class="col-12 q-mt-xl mobile" v-if="selected.length > 0">
      <div>
        <q-table
          grid
          :rows="selected"
          color="primary"
          :columns="columns2"
          row-key="id"
          class="my-sticky-header-table"
          flat
          dense
          hide-pagination
          :loading="loading"
          :rows-per-page-options="[0]"
          hide-bottom
        >
          <template v-slot:top-left>
            <span
              style="
                font-size: 16px;
                display: block;
                margin-left: -15px;
                color: #21324a;
              "
              >Produtos Selecionados</span
            >
          </template>
          <template v-slot:item="props">
            <div class="q-pa-xs col-xs-12 col-sm-6 col-md-4">
              <div class="row card">
                <div class="col-3 q-mr-sm text-center q-mt-md">
                  <div
                    v-if="props.row.product_images.length != 0"
                    class="img-container-grid q-ml-sm"
                  >
                    <q-img
                      v-if="props.row.product_images.length != 0"
                      :src="props.row.product_images[0].url"
                      fit="contain"
                      class="img-grid"
                    />
                  </div>
                  <div class="img-container-grid q-ml-sm" v-else>
                    <span class="img-grid"></span>
                  </div>
                </div>
                <div class="col">
                  <q-card-section class="row text-brand-5 text-grid-table">
                    <div class="col-12" style="margin-bottom: 3px">
                      <span><strong>Código:</strong> {{ props.row.code }}</span>
                      <span class="q-mr-sm"
                        ><strong>Nome:</strong>
                        {{
                          props.row?.pivot &&
                          props.row?.pivot.contract_product_description
                            ? props.row?.pivot.contract_product_description
                            : props.row?.name
                        }}</span
                      >
                    </div>
                    <div class="col-12" style="margin-bottom: 3px">
                      <span>
                        <strong>CA:</strong>
                        <span
                          v-if="
                            props.row.ca_codigo &&
                            props.row.ca_codigo.toString().trim() !== ''
                          "
                          class="ca-link"
                          @click="
                            validarCa(
                              props.row.ca_codigo,
                              props.row.pivot?.ca?.id
                            )
                          "
                          style="
                            color: #1976d2;
                            cursor: pointer;
                            text-decoration: underline;
                          "
                        >
                          {{ props.row.ca_codigo }}
                        </span>
                        <span v-else>-</span>
                      </span>
                    </div>
                    <div class="col-12" style="margin-bottom: 3px">
                      <span
                        ><strong>Estoque:</strong>
                        {{
                          parseInt(props.row.stock[0].pivot.amount).toFixed(2)
                        }}</span
                      >
                    </div>
                    <div class="col-12" style="margin-bottom: 3px">
                      <span
                        ><strong>Grupo de Produto</strong>
                        {{ props.row?.pivot?.product_group?.name }}
                      </span>
                    </div>
                    <div class="col-12">
                      <div class="col-12">
                        <div class="text-brand-5 btn-grid-container">
                          <div class="row col-12 items-center">
                            <div class="q-mr-sm">
                              <p></p>
                              <q-icon
                                class="arrow"
                                name="arrow_left"
                                style="background: #6391f4"
                                @click="
                                  !autenticacao
                                    ? props.row.quantidade != null &&
                                      props.row.quantidade > 0
                                      ? props.row.quantidade--
                                      : ''
                                    : ''
                                "
                              />
                            </div>
                            <div
                              class="row col-2 justify-center input-quantidade-container"
                              style="border-bottom: 1px solid #505050"
                            >
                              <q-input
                                class="input-quantidade"
                                borderless
                                dense
                                type="number"
                                v-model="props.row.quantidade"
                                min="0"
                              />
                            </div>
                            <div class="q-ml-sm">
                              <p></p>
                              <div class="arrow-container">
                                <q-icon
                                  name="arrow_right"
                                  class="arrow"
                                  style="background: #6391f4"
                                  @click="
                                    !autenticacao
                                      ? props.row.quantidade == null
                                        ? (props.row.quantidade = 1)
                                        : props.row.quantidade++
                                      : ''
                                  "
                                />
                              </div>
                            </div>
                            <div class="row col justify-center q-ml-xl">
                              <div>
                                <p></p>
                                <q-icon
                                  name="close"
                                  style="
                                    font-size: 28px;
                                    margin: 0px 0px 3px 0px;
                                    cursor: pointer;
                                  "
                                  color="red"
                                  @click="
                                    !autenticacao
                                      ? removerProduto(props.row.id)
                                      : ''
                                  "
                                ></q-icon>
                              </div>
                              <div class="q-ml-sm">
                                <p></p>
                                <q-icon
                                  name="manage_search"
                                  style="
                                    font-size: 28px;
                                    margin: 0px 0px 3px 0px;
                                    cursor: pointer;
                                  "
                                  color="black"
                                  @click="
                                    (item = {
                                      nome: props.row.name,
                                      id: props.row.code,
                                    }),
                                      atualizarHistorico++
                                  "
                                ></q-icon>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </q-card-section>
                </div>
              </div>
            </div>
          </template>
        </q-table>
      </div>
    </div>
    <div class="col-12 q-mt-xl desktop" v-if="selected.length > 0">
      <div>
        <q-table
          :rows="selected"
          color="primary"
          :columns="columns2"
          row-key="id"
          dense
          class="tabela-tamanho-fixo"
          flat
          hide-pagination
          :loading="loading"
          :rows-per-page-options="[0]"
          hide-bottom
        >
          <template v-slot:top-left>
            <span
              style="
                font-size: 16px;
                display: block;
                margin-left: -15px;
                color: #21324a;
              "
              >Produtos Selecionados</span
            >
          </template>
          <template v-slot:header="props">
            <q-tr :props="props">
              <q-th v-for="col in props.cols" :key="col.name" :props="props">
                {{ col.label }}
              </q-th>
            </q-tr>
          </template>
          <template v-slot:body="props">
            <q-tr class="text-brand-5 text-weight-bold">
              <q-td>
                <q-btn
                  icon="close"
                  color="red"
                  round
                  dense
                  :disable="autenticacao"
                  @click="removerProduto(props.row.id)"
                />
              </q-td>
              <q-td>
                <span>{{ props.row.code }}</span>
              </q-td>
              <q-td>
                <span>{{
                  props.row?.pivot &&
                  props.row?.pivot.contract_product_description
                    ? props.row?.pivot.contract_product_description
                    : props.row?.name
                }}</span>
              </q-td>
              <q-td>
                <span>{{ props.row.stock[0]?.pivot.address }}</span>
              </q-td>
              <q-td>
                <span>{{ props.row.stock[0]?.pivot.measurement_unit }}</span>
              </q-td>
              <q-td>
                <span
                  v-if="
                    props.row.ca_codigo &&
                    props.row.ca_codigo.toString().trim() !== ''
                  "
                  class="ca-link"
                  @click="
                    validarCa(props.row.ca_codigo, props.row.pivot?.ca?.id)
                  "
                  style="
                    color: #1976d2;
                    cursor: pointer;
                    text-decoration: underline;
                  "
                >
                  {{ props.row.ca_codigo }}
                </span>
                <span v-else>-</span>
                <CaStatusIndicator :ca-data="props.row.pivot?.ca" />
              </q-td>
              <q-td>
                <span>{{ props.row.stock[0]?.pivot.amount }}</span>
              </q-td>
              <q-td>
                <q-input
                  dense
                  outlined
                  type="number"
                  style="width: 90px"
                  v-model="props.row.quantidade"
                  :disable="autenticacao"
                  min="0"
                />
              </q-td>
              <q-td>
                <q-btn
                  icon="manage_search"
                  flat
                  round
                  color="black"
                  @click="
                    (item = { nome: props.row.name, id: props.row.code }),
                      atualizarHistorico++
                  "
                />
              </q-td>
            </q-tr>
          </template>
        </q-table>
      </div>
    </div>
    <div class="row col-12 q-mt-lg text-brand-5 text-weight-bold">
      <div class="col-12">
        <div
          style="font-weight: 100"
          class="q-ml-sm text-brand-1 no-margin-no-padding"
        >
          Observações
        </div>
        <q-input
          type="textarea"
          dense
          outlined
          :disable="autenticacao"
          v-model="dados.observacao"
        />
      </div>
      <div
        v-if="
          $store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles.indexOf(
            'vouchers-razao-criacao'
          ) != -1
        "
        class="q-mt-lg text-brand-5 text-weight-bold"
      >
        <span
          style="font-weight: 100"
          class="row col-12 text-brand-1 texto-autenticacao"
          >Selecione o Motivo para a Solicitação dessa requisição
          <span style="color: #8a8a8a" class="q-ml-sm">(Opcional)</span></span
        >
        <q-radio
          v-model="dados.motivoRequisicao"
          label="Perda"
          val="Perda"
          :size="mobile ? 'sm' : 'lg'"
        />
        <q-radio
          v-model="dados.motivoRequisicao"
          label="Roubo"
          val="Roubo"
          :size="mobile ? 'sm' : 'lg'"
        />
        <q-radio
          v-if="
            !$store.state.autenticacao.cliente.includes('acciona') &&
            !$store.state.autenticacao.cliente.includes('staging-acciona')
          "
          v-model="dados.motivoRequisicao"
          label="Desgaste Natural"
          val="Desgaste Natural"
          :size="mobile ? 'sm' : 'lg'"
        />
        <q-radio
          v-model="dados.motivoRequisicao"
          label="Desgaste Precoce"
          val="Desgaste Precoce"
          :size="mobile ? 'sm' : 'lg'"
        />
        <q-radio
          v-if="
            $store.state.autenticacao.cliente.includes('acciona') &&
            $store.state.autenticacao.cliente.includes('staging-acciona')
          "
          v-model="dados.motivoRequisicao"
          label="Possivel Defeito de Fabricação"
          val="Possivel Defeito de Fabricação"
          :size="mobile ? 'sm' : 'lg'"
        />
        <q-radio
          v-if="
            $store.state.autenticacao.cliente.includes('acciona') &&
            $store.state.autenticacao.cliente.includes('staging-acciona')
          "
          v-model="dados.motivoRequisicao"
          label="Atividade Emergencial"
          val="Atividade Emergencial"
          :size="mobile ? 'sm' : 'lg'"
        />

        <q-radio
          v-model="dados.motivoRequisicao"
          label="Outros"
          val="Outros"
          :size="mobile ? 'sm' : 'lg'"
        />
      </div>
    </div>
    <div
      style="max-width: 70%"
      v-if="dados.motivoRequisicao == 'Outros'"
      class="column col-md-8 col-sm-6 col-xs-6"
    >
      <div class="texto-titulo-input">Digite o motivo da retirada</div>
      <q-input
        v-model="dados.motivoRequisicaoOutros"
        dense
        outlined
        class="select"
      />
    </div>

    <div class="row col-12 q-mt-lg container-btn">
      <div>
        <q-btn
          v-if="!autenticacao"
          label="Abrir Requisição"
          icon="add"
          :disable="botaoRequisicaoTravar"
          style="background-color: #21324a; border-radius: 8px; color: white"
          no-caps
          @click="criarRequisicao()"
        />
      </div>
    </div>
    <div class="q-mt-lg text-brand-5 text-weight-bold" v-if="autenticacao">
      <span class="row col-12 texto-autenticacao">{{
        `Sua requsição foi criada com o número ${dados.idRequisicaoGerada}, selecione o tipo de autenticação abaixo para já confirmar a entrega!`
      }}</span>
      <div class="col-12 q-mt-md">
        <div class="row col-12 container-autenticacao">
          <q-radio
            v-if="
              !$store.state.autenticacao.cliente.includes('staging-vale') &&
              !$store.state.autenticacao.cliente.includes('vale-epiexpress') &&
              $store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles.indexOf(
                'voucher-auth-assinatura'
              ) != -1
            "
            v-model="dados.tipoAutenticacao"
            label="Assinatura"
            val="assinatura"
            :size="mobile ? 'sm' : 'lg'"
          />
          <q-radio
            v-model="dados.tipoAutenticacao"
            label="Biometria"
            val="biometria"
            :size="mobile ? 'sm' : 'lg'"
            v-if="
              !mobile &&
              $store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles.indexOf(
                'voucher-auth-biometria'
              ) != -1
            "
          />
          <q-radio
            v-if="
              !$store.state.autenticacao.cliente.includes('staging-acciona') &&
              !$store.state.autenticacao.cliente.includes('acciona') &&
              $store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles.indexOf(
                'voucher-auth-pin'
              ) != -1
            "
            v-model="dados.tipoAutenticacao"
            label="PIN"
            val="web_pin"
            :size="mobile ? 'sm' : 'lg'"
          />
          <q-radio
            v-if="
              $store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles.indexOf(
                'voucher-auth-token'
              ) != -1
            "
            v-model="dados.tipoAutenticacao"
            label="Token"
            val="token"
            :size="mobile ? 'sm' : 'lg'"
          />
          <q-radio
            v-if="
              $store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles.indexOf(
                'vouchers-auth-facial'
              ) != -1
            "
            v-model="dados.tipoAutenticacao"
            label="Facial"
            val="facial"
            :size="mobile ? 'sm' : 'lg'"
          />
          <div
            v-if="
              $store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles.indexOf(
                'voucher-auth-pin'
              ) == -1 &&
              $store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles.indexOf(
                'voucher-auth-biometria'
              ) == -1 &&
              $store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles.indexOf(
                'voucher-auth-assinatura'
              ) == -1
            "
            class="q-my-md"
          >
            <span
              >Você não possui nenhum método de autenticação associado ao seu
              usuário, entre em contato com o suporte.</span
            >
          </div>
          <div
            class="row col-12 q-mt-lg q-ml-md items-center container-autenticacao-pin"
            v-if="dados.tipoAutenticacao === 'web_pin'"
          >
            <q-icon class="q-mr-xs" name="lock" size="28px" />
            <div class="col-md-2 col-xs-6">
              <q-input v-model="pin" type="password" dense outlined />
            </div>
          </div>
        </div>
        <div
          @click="facial = true"
          style="cursor: pointer"
          class="q-ml-lg q-mt-md"
          v-if="dados.tipoAutenticacao == 'facial'"
        >
          <div class="relative-position" style="display: inline-block">
            <q-icon
              v-if="dados.usuario?.biometria_facial"
              size="60px"
              class="q-mr-xs"
              name="face"
              :color="imagemBase64 == null ? 'yellow' : 'positive'"
            />
            <q-icon
              v-else
              size="60px"
              class="q-mr-xs"
              name="face"
              color="negative"
            />
            <q-icon
              v-if="dados.usuario?.biometria_facial"
              :name="imagemBase64 == null ? 'schedule' : 'check_circle'"
              :style="{
                color: imagemBase64 == null ? '#ffea00' : '#2E7D32',
              }"
              size="22px"
              class="absolute-bottom-right"
              style="bottom: 2px; right: -2px; z-index: 0"
            >
              <q-tooltip
                anchor="top middle"
                self="bottom middle"
                :class="
                  imagemBase64 == null
                    ? 'bg-gray text-white'
                    : 'bg-gray text-white'
                "
              >
                {{
                  imagemBase64 == null
                    ? "Aguardando captura da face"
                    : "Face capturada com sucesso"
                }}
              </q-tooltip>
            </q-icon>
            <q-icon
              v-else
              name="cancel"
              style="color: #c62828; bottom: 2px; right: -2px; z-index: 0"
              size="22px"
              class="absolute-bottom-right"
            >
              <q-tooltip
                anchor="top middle"
                self="bottom middle"
                class="bg-gray text-white"
              >
                Face não cadastrada
              </q-tooltip>
            </q-icon>
          </div>

          <span
            v-if="dados.usuario?.biometria_facial"
            class="q-ml-sm text-bold text-brand-5"
            style="font-size: 16px"
          >
            Clique no ícone da face para reconhecimento, após leitura, clique em
            CONFIRMAR ENTREGA
          </span>

          <span
            v-else
            class="q-ml-sm text-bold text-brand-5"
            style="font-size: 14px"
          >
            O funcionário não possui face cadastrada, favor clicar no ícone e
            realizar o procedimento de cadastro antes da finalização da
            requisição
          </span>
        </div>

        <VerificacaoFacial
          v-if="
            dados.usuario?.biometria_facial &&
            facial &&
            dados.tipoAutenticacao == 'facial'
          "
          :userId="dados.usuario.idTabela"
          v-model="facial"
          @close="fecharFacial"
          @sendFace="receberFace"
        />

        <VerificacaoFacial
          v-if="
            !dados.usuario?.biometria_facial &&
            facial &&
            dados.tipoAutenticacao == 'facial'
          "
          :userId="dados.usuario.idTabela"
          v-model="facial"
          :tipoCadastro="true"
          @close="fecharFacial"
          @sendFace="receberFaceCadastro"
          @atualizarFacial="atualizarTemplatesFacial"
        />
        <div class="q-mt-md">
          <div v-if="dados.tipoAutenticacao == 'biometria'">
            <div class="row col-12 items-center">
              <div v-if="dados.usuario.biometria">
                <q-img
                  v-if="usuarioVerificado"
                  class="imagem-biometria"
                  src="../../../assets/bioOK.png"
                  @click="biometria = !biometria"
                />
                <q-img
                  v-else
                  class="imagem-biometria"
                  src="../../../assets/bioRequest.png"
                  @click="biometria = !biometria"
                />
                <span
                  class="q-ml-sm text-bold text-brand-5"
                  style="font-size: 16px"
                  >Clique no icone da digital para reconhecimento da biometria,
                  após leitura, clique em CONFIRMAR ENTREGA</span
                >
                <Biometria
                  :modal="biometria"
                  :userId="dados.usuario.idTabela"
                  :titulo="'Verificação de Biometria'"
                  :tipoBiometria="'verificacao'"
                  @negativePrint="recebeBiometria"
                  @resultadoVerificacao="receberResultadoBiometria"
                />
              </div>
              <div v-else class="row col-12">
                <q-img
                  class="imagem-biometria"
                  src="../../../assets/bioNO.png"
                  @click="biometria = !biometria"
                />
                <div class="col">
                  <div class="row col-12 q-mb-sm">
                    <q-btn
                      dense
                      color="positive"
                      icon="sync"
                      label="Indexar Biometrias"
                      no-caps
                      @click="atualizarTemplatesBiometria()"
                    />
                  </div>
                  <span
                    class="q-ml-sm text-bold text-brand-5"
                    style="font-size: 14px"
                    >O funcionário não possuiu biometria cadastrada, favor
                    clicar no icone e realizar o procedimento de cadastro antes
                    da finalização da requisição</span
                  >
                </div>
                <Biometria
                  :modal="biometria"
                  :userId="dados.usuario.idTabela"
                  :titulo="'Cadastro de Biometria'"
                  :tipoBiometria="'cadastro'"
                  @atualizarBiometrias="atualizarTemplatesBiometria"
                />
              </div>
            </div>
          </div>
          <div
            v-if="dados.tipoAutenticacao == 'assinatura'"
            class="row col-12 q-mt-md canvas-container"
          >
            <Canvas @update="recebeAssinatura" :go="salvarAssinatura" />
          </div>
        </div>
      </div>
      <span
        v-if="
          $store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles.includes(
            'voucher-data-retroativa-fluxo-completo'
          )
        "
        class="row col-2 texto-autenticacao"
        >Data Retirada</span
      >
      <div
        v-if="
          $store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles.includes(
            'voucher-data-retroativa-fluxo-completo'
          )
        "
        style="max-width: 20%"
        class="col-md-3 data-retirada-container"
      >
        <q-input
          class="input"
          v-model="dados.dataRetroativa"
          dense
          outlined
          placeholder="Data de Retirada"
          mask="##/##/####"
          :error="!!dataRetroativaErro"
          :error-message="dataRetroativaErro"
        >
          <template v-slot:append>
            <q-icon name="event" class="cursor-pointer">
              <q-popup-proxy
                cover
                transition-show="scale"
                transition-hide="scale"
              >
                <q-date
                  v-model="dados.dataRetroativa"
                  :locale="myLocale"
                  mask="DD/MM/YYYY"
                  :options="optionsFn"
                >
                  <div class="row items-center justify-end">
                    <q-btn v-close-popup label="Fechar" color="primary" flat />
                  </div>
                </q-date>
              </q-popup-proxy>
            </q-icon>
          </template>
        </q-input>
      </div>
      <div class="row col-12 justify-start q-mt-lg container-btn">
        <q-btn
          label="Confirmar Entrega"
          color="positive"
          no-caps
          :disable="botaoRequisicaoTravar || !!dataRetroativaErro"
          icon="add"
          @click="
            dados.tipoAutenticacao == 'web_pin' ? checarPin() : '';
            dados.tipoAutenticacao == 'assinatura' ? salvarAssinatura++ : '';
            dados.tipoAutenticacao == 'biometria' ? finalizarRequisicao() : '';
            dados.tipoAutenticacao == 'token' ? finalizarRequisicao() : '';
            dados.tipoAutenticacao == 'facial' ? finalizarRequisicao() : '';
            dados.tipoAutenticacao == ''
              ? quasar.notify({
                  message: 'Selecione um método de autenticação',
                  color: 'negative',
                  actions: [
                    {
                      label: 'fechar',
                      color: 'white',
                      handler: () => {
                        /* ... */
                      },
                    },
                  ],
                })
              : '';
          "
        />
      </div>
    </div>

    <TabelaHistoricoRetirada
      :solicitanteId="dados.usuario"
      :item="item"
      :atualizar="atualizarHistorico"
    />

    <!-- Modal para exibição da imagem ampliada -->
    <q-dialog
      v-model="imagemAmpliada"
      maximized
      @click="imagemAmpliada = false"
    >
      <q-card class="imagem-ampliada-container" @click.stop>
        <q-card-section class="row items-center justify-end q-pa-sm">
          <q-btn
            icon="close"
            flat
            round
            color="white"
            size="md"
            class="botao-fechar"
            @click="imagemAmpliada = false"
          />
        </q-card-section>
        <q-card-section
          class="q-pa-none flex flex-center"
          @click="imagemAmpliada = false"
        >
          <q-img :src="imagemUrl" fit="contain" class="imagem-ampliada" />
        </q-card-section>
      </q-card>
    </q-dialog>

    <!-- Modal de Validação de CA -->
    <CaValidationModal
      v-model="isValidationModalOpen"
      :ca-number="selectedCaNumber"
      :ca-id="selectedCaId"
      @ca-updated="handleCaUpdated"
    />
  </q-page>
</template>

<script>
import { onMounted, ref, watch, computed } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import DialogConfirm from "../components/DialogConfirm.vue";
import Biometria from "../../biometria/views/Biometria.vue";
import ListaUnidadesSelect from "../../organizacional/unidade/component/ListaUnidadesSelect.vue";
import TabelaHistoricoRetirada from "../components/TabelaHistoricoRetirada.vue";
import Canvas from "../components/Canvas.vue";
import SelecaoFuncionario from "../../ferramentaria/components/SelecaoFuncionario.vue";
import VerificacaoFacial from "../components/VerificacaoFacial.vue";
import CaValidationModal from "../../../components/CaValidationModal.vue";
import CaStatusIndicator from "../../../components/CaStatusIndicator.vue";
import { useCaValidation } from "../../../composables/useCaValidation.js";
import { watchDebounced } from "@vueuse/core";

const columnsLiberados = [
  {
    name: "selecionar",
    label: "Selecionar",
    align: "center",
    style: "white-space: normal",
  },
  {
    name: "codigo",
    label: "Código",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "descricao",
    label: "Descrição",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "endereco",
    label: "Endereço",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "unidadeMedida",
    label: "Unidade de Medida",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "ca_codigo",
    label: "CA",
    align: "left",
    sortable: false,
    style: "white-space: normal",
  },
  {
    name: "estoque",
    label: "Estoque",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "critico",
    label: "Critico",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "quantidade",
    label: "QTD",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "retirar",
    label: "Pode Retirar (S/N)",
    align: "left",
    sortable: false,
    style: "white-space: normal",
  },
];
const columns2 = [
  {
    name: "selecionar",
    label: "",
    align: "center",
    style: "white-space: normal",
  },
  {
    name: "codigo",
    label: "Código",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "descricao",
    label: "Descrição",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "endereco",
    label: "Endereço",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "unidadeMedida",
    label: "Unidade de Medida",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "ca_codigo",
    label: "CA",
    align: "left",
    sortable: false,
    style: "white-space: normal",
  },
  {
    name: "estoque",
    label: "Estoque",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "quantidade",
    label: "QTD",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "retiradas",
    label: "Retiradas",
    align: "left",
    style: "white-space: normal",
  },
];
export default {
  components: {
    Biometria,
    ListaUnidadesSelect,
    TabelaHistoricoRetirada,
    Canvas,
    SelecaoFuncionario,
    DialogConfirm,
    VerificacaoFacial,
    CaValidationModal,
    CaStatusIndicator,
  },
  setup() {
    const columns = [
      {
        name: "selecionar",
        label: "Selecionar",
        align: "center",
        style: (row) =>
          row.critico == 1 && compararDataCritico(row)
            ? "background-color: #DD2153;"
            : "",
      },
      {
        name: "imagem",
        label: "Imagem",
        align: "center",
        style: (row) =>
          row.critico == 1 && compararDataCritico(row)
            ? "background-color: #DD2153;"
            : "",
      },
      {
        name: "codigo",
        label: "Código",
        align: "left",
        style: (row) =>
          row.critico == 1 && compararDataCritico(row)
            ? "background-color: #DD2153;"
            : "",
      },
      {
        name: "descricao",
        label: "Descrição",
        align: "left",
        style: (row) =>
          row.critico == 1 && compararDataCritico(row)
            ? "background-color: #DD2153;"
            : "",
      },
      {
        name: "endereco",
        label: "Endereço",
        align: "left",
        style: (row) =>
          row.critico == 1 && compararDataCritico(row)
            ? "background-color: #DD2153;"
            : "",
      },
      {
        name: "unidadeMedida",
        label: "Unidade de Medida",
        align: "left",
        style: (row) =>
          row.critico == 1 && compararDataCritico(row)
            ? "background-color: #DD2153;"
            : "",
      },
      {
        name: "ca_codigo",
        label: "CA",
        align: "left",
        sortable: false,
        style: (row) =>
          row.critico == 1 && compararDataCritico(row)
            ? "background-color: #DD2153;"
            : "",
      },
      {
        name: "ca_status",
        label: "Status",
        align: "left",
        sortable: false,
        style: (row) =>
          row.critico == 1 && compararDataCritico(row)
            ? "background-color: #DD2153;"
            : "",
      },
      {
        name: "critico",
        label: "Critico",
        align: "left",
        style: (row) =>
          row.critico == 1 && compararDataCritico(row)
            ? "background-color: #DD2153;"
            : "",
      },
      {
        name: "estoque",
        label: "Estoque",
        align: "left",
        style: (row) =>
          row.critico == 1 && compararDataCritico(row)
            ? "background-color: #DD2153;"
            : "",
      },
      {
        name: "quantidade",
        label: "QTD",
        align: "left",
        style: (row) =>
          row.critico == 1 && compararDataCritico(row)
            ? "background-color: #DD2153;"
            : "",
      },
      {
        name: "retirar",
        label: "Pode Retirar (S/N)",
        align: "left",
        sortable: false,
        style: (row) =>
          row.critico == 1 && compararDataCritico(row)
            ? "background-color: #DD2153;"
            : "",
      },
    ];

    const store = useStore();
    const quasar = useQuasar();
    const facial = ref(false);
    // Inicializa saldo com base no tenant (Acciona = "com-saldo", outros = "" para "Todos")
    const saldo = ref("");
    const atualDate = ref(new Date().toLocaleString("pt-br"));
    let unidade = ref({
      nome: store.state.org.unidadeData,
      id: store.state.org.unidadeData.id,
    });
    const listaContratosOptions = ref([]);
    const dados = ref({
      contrato: { label: "Contrato", id: "" },
      usuario: "",
      observacao: "",
      dataAtual: new Date().toLocaleDateString("pt-BR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      }),
      idRequisicaoGerada: "",
      tipoAutenticacao: "",
      motivoRequisicao: "",
      motivoRequisicaoOutros: undefined,
      solicitanteId: "",
      dataRetroativa: null,
    });
    const centroCustoUsuario = ref(null);
    const crachaSolicitante = ref(null);
    const usuarioEncontradoPorCracha = ref(null);
    const solicitanteMatricula = ref(null);
    const solicitantePesquisa = ref(null);
    const filtros = ref({
      usuario: "",
      produto: "",
      tipoRequisicao: "",
      caCodigo: "",
      caStatus: null,
    });
    const listaUsuarios = ref([]);
    let loadingInner = ref(false);
    const listaProdutos = ref([]);
    const selected = ref([]);
    let autenticacao = ref(false);
    const aviso = ref(false);
    const linha = ref(null);
    const pin = ref("");
    let biometria = ref(false);
    let imagemBase64 = ref(null);
    let mobile = ref(false);
    let loading = ref(false);
    let usuarioVerificado = ref(false);
    const listarTodos = ref(true);
    let salvarAssinatura = ref(0);
    let atualizarUsuario = ref(0);
    const lotes = ref([]);
    const botaoRequisicaoTravar = ref(false);
    const userLogadoId = ref("");
    const item = ref({ nome: "", id: "" });
    const atualizarHistorico = ref(0);

    // Controle para visualização ampliada da imagem
    const imagemAmpliada = ref(false);
    const imagemUrl = ref("");

    // Validação de CA
    const {
      isModalOpen: isValidationModalOpen,
      openValidationModal,
      closeValidationModal,
    } = useCaValidation();
    const selectedCaNumber = ref("");
    const selectedCaId = ref(null);

    // Controle para confirmação de mudança de tipo de requisição
    const tipoRequisicaoAnterior = ref("");

    // Função para abrir a imagem em tamanho ampliado
    const abrirImagemAmpliada = (url) => {
      imagemUrl.value = url;
      imagemAmpliada.value = true;
    };

    // Função para validar CA
    const validarCa = (caNumber, caId = null) => {
      // Debug: verificar se o ID está sendo passado
      console.log("validarCa chamado com:", { caNumber, caId });

      // Verifica se o parâmetro é null, undefined ou vazio antes de processar
      if (caNumber === null || caNumber === undefined) {
        quasar.notify({
          message: "Número do CA é obrigatório",
          color: "negative",
          actions: [{ label: "Fechar", color: "white" }],
        });
        return;
      }

      // Converte para string e remove espaços
      const caString = String(caNumber).trim();

      // Verifica se o CA é válido após conversão
      if (
        caString === "" ||
        caString === "null" ||
        caString === "undefined" ||
        caString.length === 0
      ) {
        quasar.notify({
          message: "Número do CA é obrigatório",
          color: "negative",
          actions: [{ label: "Fechar", color: "white" }],
        });
        return;
      }

      selectedCaNumber.value = caString;
      selectedCaId.value = caId;
      openValidationModal(caString, caId);
    };

    // Função para lidar com atualização de CA
    const handleCaUpdated = () => {
      // Recarregar a lista de produtos se necessário
      listarProdutos();
      closeValidationModal();
    };

    // Função para interceptar mudança do tipo de requisição
    const interceptarMudancaTipoRequisicao = async (novoTipo) => {
      // Verifica se o radio está desabilitado antes de processar
      const isDisabled =
        (!dados.value.usuario && !crachaSolicitante.value) ||
        autenticacao.value ||
        store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles.indexOf(
          `voucher-produto-${
            novoTipo === "all"
              ? "todos"
              : novoTipo === "liberados"
              ? "liberados"
              : "epis"
          }`
        ) != -1;

      if (isDisabled) {
        console.log(
          `Tentativa de mudança bloqueada para ${novoTipo} - botão desabilitado`
        );
        return; // Sai da função se estiver desabilitado
      }

      // Se estava em "liberados" e está tentando mudar para "all" ou "yes" (Todos ou Todos EPI)
      // E se o tenant for ACCIONA ou STAGING-MULTPEX
      if (
        tipoRequisicaoAnterior.value === "liberados" &&
        (novoTipo === "all" || novoTipo === "yes") &&
        (store.state.autenticacao.cliente.includes("acciona") ||
          store.state.autenticacao.cliente.includes("staging-acciona") ||
          store.state.autenticacao.cliente.includes("staging-multpex"))
      ) {
        // Mostrar dialog de confirmação
        quasar
          .dialog({
            title: "⚠️ Confirmação de Mudança",
            message:
              "Tem certeza que deseja alterar a seleção? As entregas devem ser feitas primariamente pela opção 'Produtos Liberados', que já estava selecionada.",
            cancel: {
              label: "Manter",
              color: "primary",
              style: "width: 47%",
            },
            persistent: true,
            ok: {
              label: "Alterar",
              color: "negative",
              style: "width: 47%",
            },
          })
          .onOk(async () => {
            // Se confirmou, aplica a mudança
            tipoRequisicaoAnterior.value = novoTipo;
            filtros.value.tipoRequisicao = novoTipo;

            // Enviar dados para o webhook
            try {
              const opcaoSelecionada =
                novoTipo === "all" ? "Todos" : "Todos EPI";
              const payload = {
                timestamp: new Date().toISOString(),
                nome_usuario:
                  store.state.autenticacao.usuarioLogado?.nome || "N/A",
                email_usuario:
                  store.state.autenticacao.usuarioLogado?.email || "N/A",
                opcao_selecionada: opcaoSelecionada,
              };

              await fetch(
                "https://n8n.devops.multpex.com.br/webhook/cfa544a0-3c6f-46d1-9f98-f7ed75cb9395",
                {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify(payload),
                }
              );
            } catch (error) {
              console.error("Erro ao enviar dados para o webhook:", error);
              // Não interrompe o fluxo normal mesmo se o webhook falhar
            }
          })
          .onCancel(() => {
            // Se cancelou, volta para "liberados"
            filtros.value.tipoRequisicao = "liberados";
          });
      } else {
        // Se não estava em "liberados" ou não está mudando para "all"/"yes", ou não é ACCIONA/STAGING-MULTPEX, aplica normalmente
        tipoRequisicaoAnterior.value = novoTipo;
        filtros.value.tipoRequisicao = novoTipo;
      }
    };

    if (quasar.platform.is.mobile) {
      mobile = ref(true);
      dados.value.tipoAutenticacao = "web_pin";
    }
    const listarContratos = async () => {
      await unidade.value.id;
      try {
        const response = await store.dispatch("requisicao/listarContratos", {
          per_page: 100,
        });
        let array = response.data.results.data;
        listaContratosOptions.value = [];
        array.forEach((contrato) => {
          listaContratosOptions.value.push({
            label: contrato.contract.description,
            id: contrato.pivot.vendor_id,
          });
        });
        selecionarContrato();
      } catch (error) {
        console.log(error);
      }
    };

    const selecionarContrato = () => {
      let valor = listaContratosOptions.value.filter((contrato) => {
        return contrato.id == unidade.value.id;
      });
      dados.value.contrato.label = valor[0]?.label;
      dados.value.contrato.id = valor[0]?.id;
    };

    const listarUsuarios = async (val) => {
      await store.state.autenticacao.cliente;
      try {
        loadingInner.value = true;
        const response = await store.dispatch("requisicao/listarSolicitante", {
          per_page: 4,
          vendor_id:
            store.state.autenticacao.cliente.includes("acciona") ||
            store.state.autenticacao.cliente.includes("vale-epiexpress")
              ? ""
              : unidade.value.id,
          search: val,
        });

        listaUsuarios.value = response.data.results.data.map((e) => {
          return { alternativeName: `${e.name} - ${e.email}`, ...e };
        });

        if (autenticacao.value) {
          let array = listaUsuarios.value.filter((user) => {
            return dados.value.usuario.id == user.id;
          });
          dados.value.usuario = array[0];
        }
        loadingInner.value = false;
      } catch (error) {
        console.log(error);
      }
    };

    const listarProdutos = async () => {
      listaProdutos.value = [];

      try {
        loading.value = true;
        const response = await store.dispatch("requisicao/listarProdutos", {
          per_page: 50,
          vendor_id: unidade.value.id,
          search: filtros.value.produto,
          contract_id: await store.state.org.contract,
          plantiff_id: dados.value.usuario?.idTabela,
          has_ca: filtros.value.tipoRequisicao,
          saldo: saldo.value == "" ? undefined : saldo.value,
          ca: filtros.value.caCodigo || undefined,
          ca_status: filtros.value.caStatus?.value,
        });

        let produtos = response.data.results.data.products;

        if (filtros.value.caStatus?.value) {
          produtos = produtos.filter((produto) => {
            const status = produto.ca_status || produto.pivot?.ca?.status;
            return status === filtros.value.caStatus.value;
          });
        }

        produtos.forEach((e) => {
          listaProdutos.value.push({
            ...e,
            ca_codigo: e?.pivot?.ca?.code,
            ca_status: e?.pivot?.ca?.status,
          });
        });

        loading.value = false;
      } catch (error) {
        console.log(error);
        loading.value = false;
      }
    };

    const listarProdutosLiberados = async () => {
      try {
        loading.value = true;
        const response = await store.dispatch(
          "requisicao/listarProdutosLiberados",
          {
            vendor_id: unidade.value.id,
            user_id: dados.value.usuario?.idTabela,
            search:
              filtros.value.produto == "" ? undefined : filtros.value.produto,
            per_page: 50,
            saldo: saldo.value == "" ? undefined : saldo.value,
            ca: filtros.value.caCodigo || undefined,
            ca_status: filtros.value.caStatus?.value || "",
          }
        );

        if (response.data.data.length > 0) {
          let novaLista = response.data.data.map((e) => {
            return {
              product_images: e.produto_url ? [{ url: e.produto_url }] : [],
              name: e.descricao,
              description: e.descricao,
              stock: [
                {
                  pivot: { amount: e.estoque },
                  minimal_amount: e.estoque_minimo,
                },
              ],
              code: e.produto_codigo,
              id: e.produto_id,
              pode_retirar: e.pode_retirar,
              max_amount: e.max_amount,
              critico: e.critico,
              withdrawal_amount: e.withdrawal_amount,
              next_maximum_withdrawal: e.next_maximum_withdrawal,
              next_minimum_withdrawal: e.next_minimum_withdrawal,
              ca_codigo: e.ca_codigo || e?.pivot?.ca?.code,
              ca_status: e.ca_status,
              pivot: {
                price: e.preco,
                ca: e.ca_status ? { status: e.ca_status } : null,
              },
            };
          });

          if (filtros.value.caStatus?.value) {
            novaLista = novaLista.filter((produto) => {
              return produto.ca_status === filtros.value.caStatus.value;
            });
          }

          listaProdutos.value = novaLista;
          loading.value = false;
          return;
        }
        listaProdutos.value = [];
        loading.value = false;
      } catch (error) {
        loading.value = false;
        console.log(error);
      }
    };

    const removerProduto = (id) => {
      selected.value = selected.value.filter((produto) => {
        return produto.id != id;
      });
    };

    const criarRequisicao = async () => {
      if (
        unidade.value.id == "218" &&
        (store.state.autenticacao.cliente[0] == "staging-vale" ||
          store.state.autenticacao.cliente[0] == "vale-epiexpress")
      ) {
        quasar.notify({
          message: "Selecione outro posto para a criação da requisição",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      if (
        unidade.value.id == "1" &&
        (store.state.autenticacao.cliente[0] == "cbmsa" ||
          store.state.autenticacao.cliente[0] == "staging-cbmsa")
      ) {
        quasar.notify({
          message: "Selecione outro posto para a criação da requisição",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      if (selected.value.length == 0) {
        quasar.notify({
          message: "Selecione ao menos um item para criar a requisição.",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      let produtos = [];
      selected.value.forEach((produto) => {
        let array = [];
        array = Object.keys(produto);
        let existe = array.some((value) => value == "quantidade");
        if (!existe || produto.quantidade <= 0) {
          quasar.notify({
            message: `O item ${produto.name} está com quantidade zerada, altere a quantidade ou remova o item para seguir!`,
            color: "negative",
            actions: [
              {
                label: "fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          return;
        }
        produtos.push({
          amount: parseFloat(produto.quantidade),
          descricao: produto.name,
          endereco: produto.stock[0]?.pivot.address,
          estoque: produto.stock[0]?.pivot.amount,
          estoque_minimo: produto.stock[0]?.pivot.minimal_amount,
          id: produto.id,
          pode_retirar: produto.pode_retirar,
          preco: produto.pivot.price,
          unidade_medida: produto.stock[0]?.pivot.measurement_unit,
        });
      });
      if (selected.value.length != produtos.length) {
        return;
      }
      botaoRequisicaoTravar.value = true;
      if (unidade.value.id == undefined || unidade.value.id == "") {
        botaoRequisicaoTravar.value = false;
        quasar.notify({
          message: "Selecione uma Unidade para criar a Requisição.",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      try {
        const response = await store.dispatch("requisicao/criarRequisicao", {
          cost_center_id: dados.value.usuario?.centroCusto,
          description: dados.value.observacao || undefined,
          plantiff_id: dados.value.usuario?.idTabela,
          products: produtos,
          vendor_id: unidade.value.id,
          voucher_reason:
            dados.value.motivoRequisicao != ""
              ? dados.value.motivoRequisicao == "Outros"
                ? dados.value.motivoRequisicaoOutros
                : dados.value.motivoRequisicao
              : undefined,
        });
        quasar.notify({
          message:
            "Voucher criado com sucesso! Ele está como rascunho, você deve entrar na listagem de vouchers e envia-lo para aprovação para dar sequência a retirada dos itens.",
          color: "positive",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        dados.value.idRequisicaoGerada = response.data.model.id;
        dados.value.solicitanteId = response.data.model.plantiff_id;
        autenticacao.value = true;
        botaoRequisicaoTravar.value = false;
        detalharRequisicao();
      } catch (error) {
        console.log(error);
        botaoRequisicaoTravar.value = false;
        quasar.notify({
          message: "Erro ao criar voucher",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const gerarDataAtual = () => {
      let dataAtual = new Date();

      let mesAtual = dataAtual.getMonth() + 1;
      let diaAtual = dataAtual.getDate();
      let anoAtual = dataAtual.getFullYear();

      dados.value.dataAtual = anoAtual + "-" + mesAtual + "-" + diaAtual;
    };

    const recebeAssinatura = async (value) => {
      imagemBase64.value = value;
      finalizarRequisicao();
    };

    const atualizarTemplatesBiometria = async () => {
      try {
        await store.dispatch("user/atualizarTemplatesBiometria");
        atualizarUsuario.value++;
      } catch (error) {
        console.log(error);
      }
    };

    const recebeBiometria = async (value) => {
      imagemBase64.value = value;
    };

    const checarPin = async () => {
      if (pin.value == "") {
        quasar.notify({
          message: "O campo não pode estar vazio",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      try {
        const response = await store.dispatch("requisicao/checarPin", {
          pin: pin.value,
          user_id: dados.value.solicitanteId,
        });
        if (response.data.result.pin_correto) {
          quasar.notify({
            message:
              "Senha Validada com Sucesso, a requisição será finalizada!",
            color: "positive",
            actions: [
              {
                label: "fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          usuarioVerificado.value = true;
          finalizarRequisicao();
        } else {
          quasar.notify({
            message: "PIN digitado, não corresponde ao pin do usuário!",
            color: "negative",
            actions: [
              {
                label: "fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
      } catch (error) {
        quasar.notify({
          message: "Erro ao validar pin",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const finalizarRequisicao = async () => {
      if (dados.value.tipoAutenticacao == "web_pin") {
        imagemBase64.value = pin.value;
      }
      if (
        dados.value.tipoAutenticacao != "token" &&
        imagemBase64.value == null
      ) {
        quasar.notify({
          message:
            "Realize a autenticação para a fazer a finalização do voucher.",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      if (
        !usuarioVerificado.value &&
        dados.value.tipoAutenticacao != "assinatura" &&
        dados.value.tipoAutenticacao != "facial"
      ) {
        quasar.notify({
          message: "A Biometria coletada não coincide com a do solicitante",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      botaoRequisicaoTravar.value = true;
      try {
        await store.dispatch("requisicao/finalizar", {
          reqId: dados.value.idRequisicaoGerada,
          imagemBase64:
            dados.value.tipoAutenticacao != "token"
              ? imagemBase64.value
              : store.state.autenticacao.token,
          idUsuario: dados.value.usuario?.idTabela,
          batches: lotes.value,
          date:
            dados.value.dataRetroativa != null
              ? converterData(dados.value.dataRetroativa)
              : gerarTimestamp(),
          auth_type: dados.value.tipoAutenticacao,
        });
        quasar.notify({
          message: "Requisição finalizada com sucesso.",
          color: "positive",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        setTimeout(() => {
          botaoRequisicaoTravar.value = false;
          location.reload();
        }, 2000);
      } catch (error) {
        console.log(error);
        botaoRequisicaoTravar.value = false;
        quasar.notify({
          message: error.response.data.message,
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const receberResultadoBiometria = (value) => {
      usuarioVerificado.value = value;
    };

    const userLogado = async () => {
      let response = await store.dispatch("requisicao/userLogado");
      userLogadoId.value = response.data.id;
    };

    const detalharRequisicao = async () => {
      lotes.value = [];
      try {
        const response = await store.dispatch("requisicao/detalharVoucher", {
          voucher_id: dados.value.idRequisicaoGerada,
        });
        let produtos = response.data.model.products;
        produtos.forEach((e) => {
          let produtoQuantidade = e.pivot?.amount;
          e.lotes.sort((a, b) => {
            if (a.expiration_date == null || b.expiration_date == null) {
              if (a.expiration_date == null) {
                return -1;
              }
              if (b.expiration_date == null) {
                return 1;
              }
            }
            if (a.expiration_date != null && b.expiration_date != null) {
              if (a.expiration_date > b.expiration_date) {
                return 1;
              }
              if (b.expiration_date > a.expiration_date) {
                return -1;
              }
            }
            return 0;
          });
          let stockVendor = e.stock.filter(
            (stock) => stock.vendor_id === store.state.org.unidadeData.id
          );
          if (e.lotes.length > 0 && stockVendor[0]?.pivot?.batch_control == 1) {
            e.lotes.forEach((lote, indice) => {
              if (
                parseFloat(lote.amount) > parseFloat(produtoQuantidade) &&
                !lotes.value.some((value) => value.product_id == e.id) &&
                lote.vendor_id == stockVendor[0]?.vendor_id
              ) {
                adicionarLote(e.id, produtoQuantidade, lote.batch);
                return;
              }
              if (
                indice + 1 == e.lotes.length &&
                !lotes.value.some((value) => value.product_id == e.id)
              ) {
                e.lotes.forEach((lote) => {
                  if (lote.vendor_id == stockVendor[0]?.vendor_id) {
                    adicionarLote(e.id, produtoQuantidade, lote.batch);
                  }
                });
                return;
              }
            });
          }
        });
      } catch (error) {
        console.log(error);
      }
      loading.value = false;
    };

    const adicionarLote = async (id, quantidade, nome) => {
      lotes.value.push({
        batch: nome,
        amount: quantidade,
        product_id: id,
      });
    };

    const receberFuncionario = (value) => {
      dados.value.usuario = value;

      centroCustoUsuario.value = `${value.centroCustoCode} - ${value.centroCustoName}`;
      dados.value.usuario.biometria_facial =
        value.biometria_facial === 1 ||
        value.biometria_facial === "1" ||
        value.biometria_facial === true;
    };

    const receberFuncionarioPorCracha = (value) => {
      solicitanteMatricula.value = value;
      solicitantePesquisa.value = value?.nome;

      dados.value.usuario = value;

      centroCustoUsuario.value = `${value.centroCustoCode} - ${value.centroCustoName}`;
      dados.value.usuario.biometria_facial =
        value.biometria_facial === 1 ||
        value.biometria_facial === "1" ||
        value.biometria_facial === true;
    };

    const gerarTimestamp = () => {
      let dataAtual = new Date();

      let ano = dataAtual.getFullYear();
      let mes = (dataAtual.getMonth() + 1).toString().padStart(2, "0");
      let dia = dataAtual.getDate().toString().padStart(2, "0");
      let horas = dataAtual.getHours().toString().padStart(2, "0");
      let minutos = dataAtual.getMinutes().toString().padStart(2, "0");
      let segundos = dataAtual.getSeconds().toString().padStart(2, "0");

      return `${ano}-${mes}-${dia}T${horas}:${minutos}:${segundos}Z`;
    };

    watch(
      () => store.state.org.unidadeData,
      () => {
        if (store.state.org.unidadeData == null) {
          return;
        }
        unidade.value.nome = store.state.org.unidadeData;
        unidade.value.id = store.state.org.unidadeData.id;
        selecionarContrato();
        listaUsuarios.value = [];
      }
    );

    watchDebounced(
      () => filtros.value.produto,
      () => {
        if (filtros.value.tipoRequisicao == "liberados") {
          listarProdutosLiberados();
          return;
        }
        listarProdutos();
      },
      { debounce: 1000 }
    );

    watchDebounced(
      () => filtros.value.caCodigo,
      () => {
        if (filtros.value.tipoRequisicao === "") {
          return;
        }
        if (filtros.value.tipoRequisicao == "liberados") {
          listarProdutosLiberados();
          return;
        }
        listarProdutos();
      },
      { debounce: 100 }
    );

    watch(
      () => filtros.value.caStatus,
      () => {
        if (filtros.value.tipoRequisicao === "") {
          return;
        }
        if (filtros.value.tipoRequisicao == "liberados") {
          listarProdutosLiberados();
          return;
        }
        listarProdutos();
      }
    );

    watch(
      () => listarTodos.value,
      () => {
        if (filtros.value.tipoRequisicao == "liberados") {
          listarProdutosLiberados();
          return;
        }
        listarProdutos();
      }
    );

    watch(
      () => filtros.value.usuario,
      () => {
        listarUsuarios();
      }
    );

    watch(
      () => dados.value.usuario,
      () => {
        // Se o tenant for ACCIONA ou STAGING-MULTPEX e um usuário foi selecionado,
        // automaticamente seleciona "Produtos Liberados"
        if (
          dados.value.usuario &&
          (store.state.autenticacao.cliente.includes("acciona") ||
            store.state.autenticacao.cliente.includes("staging-acciona") ||
            store.state.autenticacao.cliente.includes("staging-multpex"))
        ) {
          filtros.value.tipoRequisicao = "liberados";
          tipoRequisicaoAnterior.value = "liberados"; // Inicializa o tipo anterior
        }

        if (filtros.value.tipoRequisicao != "") {
          if (filtros.value.tipoRequisicao == "liberados") {
            listarProdutosLiberados();
            return;
          }
          listarProdutos();
        }
      }
    );

    watch(
      () => crachaSolicitante.value,
      () => {
        if (filtros.value.tipoRequisicao != "") {
          if (filtros.value.tipoRequisicao == "liberados") {
            listarProdutosLiberados();
            return;
          }
          listarProdutos();
        }
      }
    );

    watch(
      () => dados.value.tipoAutenticacao,
      () => {
        if (dados.value.tipoAutenticacao == "token") {
          imagemBase64.value = null;
          pin.value = "";
          usuarioVerificado.value = true;
          return;
        }
        imagemBase64.value = null;
        pin.value = "";
        usuarioVerificado.value = false;
      }
    );

    watch(
      () => filtros.value.tipoRequisicao,
      () => {
        // Atualiza o valor anterior apenas se a mudança não foi interceptada
        // (para evitar loop infinito)
        if (tipoRequisicaoAnterior.value !== filtros.value.tipoRequisicao) {
          tipoRequisicaoAnterior.value = filtros.value.tipoRequisicao;
        }

        listaProdutos.value = [];
        selected.value = [];
        filtros.value.produto = "";

        if (filtros.value.tipoRequisicao == "liberados") {
          listarProdutosLiberados();
          return;
        }
        listarProdutos();
      }
    );

    watch(
      () => saldo.value,
      () => {
        if (filtros.value.tipoRequisicao == "") {
          return;
        }
        listaProdutos.value = [];
        selected.value = [];
        filtros.value.produto = "";

        if (filtros.value.tipoRequisicao == "liberados") {
          listarProdutosLiberados();
          return;
        }
        listarProdutos();
      }
    );

    const dataRetroativaErro = ref("");

    const validateDataRetroativa = (valor) => {
      if (!valor || valor.length < 10) {
        dataRetroativaErro.value = "";
        return;
      }

      const partes = valor.split("/");
      if (partes.length !== 3) {
        dataRetroativaErro.value = "Data de retirada inválida, informe a data corretamente";
        return;
      }

      const dia = parseInt(partes[0], 10);
      const mes = parseInt(partes[1], 10);
      const ano = parseInt(partes[2], 10);

      // verifica se os valores sao numericos e a data é valida
      const dataObjeto = new Date(ano, mes - 1, dia);
      const isValida =
        !isNaN(dataObjeto.getTime()) &&
        dataObjeto.getFullYear() === ano &&
        dataObjeto.getMonth() === mes - 1 &&
        dataObjeto.getDate() === dia;

      if (!isValida) {
        dataRetroativaErro.value = "Data de retirada inválida, informe a data corretamente";
        return;
      }

      // data minima: 01/01/2000
      const dataMinima = new Date(2000, 0, 1);
      if (dataObjeto < dataMinima) {
        dataRetroativaErro.value = "Data de retirada inválida, informe a data corretamente";
        return;
      }

      // data maxima: hoje
      const hoje = new Date();
      hoje.setHours(23, 59, 59, 999);
      if (dataObjeto > hoje) {
        dataRetroativaErro.value = "A data de retirada não pode ser maior que a data atual";
        return;
      }

      dataRetroativaErro.value = "";
    };

    watch(
      () => dados.value.dataRetroativa,
      (novoValor) => {
        validateDataRetroativa(novoValor);
      }
    );

    onMounted(() => {
      listarContratos();
      gerarDataAtual();
      userLogado();
      inicializarSaldoBasedoNasPermissoes();
    });

    const compararDataCritico = (data) => {
      if (
        data.next_maximum_withdrawal == undefined ||
        data.next_maximum_withdrawal == null
      ) {
        return true;
      }

      let dataPrincipal2 = data.next_maximum_withdrawal.split(" ")[0];
      var partesData2 = dataPrincipal2.split("-");

      var dataProximaRetiradaMaxima = new Date(
        partesData2[0],
        partesData2[1] - 1,
        partesData2[2]
      );

      if (dataProximaRetiradaMaxima < new Date()) {
        return true;
      } else {
        return false;
      }
    };

    const compararData = (data, pode_retirar) => {
      if (pode_retirar == "Sim") {
        if (
          data.next_minimum_withdrawal == undefined ||
          data.next_minimum_withdrawal == null
        ) {
          return `Sim: (${parseFloat(data?.max_amount)})`;
        }

        let dataPrincipal = data.next_minimum_withdrawal.split(" ")[0];
        var partesData = dataPrincipal.split("-");

        var dataProximaRetirada = new Date(
          partesData[0],
          partesData[1] - 1,
          partesData[2]
        );

        if (dataProximaRetirada <= new Date()) {
          return `Sim (${parseFloat(data?.max_amount)})`;
        } else {
          return parseFloat(data?.max_amount) -
            parseFloat(data?.withdrawal_amount) ==
            0
            ? `Sim (0)`
            : `Sim: (${
                parseFloat(data?.max_amount) -
                parseFloat(data?.withdrawal_amount)
              })`;
        }
      } else if (pode_retirar == "Não") {
        return `Não: (0)`;
      }
    };

    const verificarQuantidade = async (row, props) => {
      if (props.selected) {
        props.selected = !props.selected;
        return;
      }

      const retirado =
        row.withdrawal_amount != null ? row.withdrawal_amount : 0;

      const valorMaximo = row.max_amount.replace(".", "");

      let dataPrincipal = row?.next_minimum_withdrawal?.split(" ")[0];
      var partesData = dataPrincipal ? dataPrincipal.split("-") : null;
      var newData =
        partesData != null
          ? new Date(partesData[0], partesData[1] - 1, partesData[2])
          : null;

      const verificarData =
        parseFloat(valorMaximo) - parseFloat(retirado) != 0
          ? parseFloat(valorMaximo) - parseFloat(retirado)
          : newData <= new Date()
          ? parseFloat(valorMaximo)
          : 0;

      /* eslint-disable-next-line */
      if (
        parseFloat(row.quantidade) > parseFloat(verificarData) ||
        row.pode_retirar == "Não"
      ) {
        aviso.value = true;
        linha.value = props;
      } else {
        props.selected = !props.selected;
      }
    };

    const verificarQuantidadeHttp = async (row, props) => {
      if (props.selected) {
        props.selected = !props.selected;
        props.row.loadingButton = false;
        return;
      }

      const response = await store.dispatch(
        "requisicao/verificaQuantidadedHttp",
        {
          productId: row.id,
          userId: dados.value.usuario.idTabela,
        }
      );

      const retirado =
        response?.data?.results[0].withdrawal_amount != null
          ? response?.data?.results[0].withdrawal_amount
          : 0;

      const valorMaximo =
        response?.data?.results[0].max_amount != null
          ? response?.data?.results[0].max_amount
          : 0;

      let dataPrincipal =
        response?.data?.results[0].next_minimum_withdrawal != null
          ? row?.next_minimum_withdrawal?.split(" ")[0]
          : false;
      var partesData = dataPrincipal ? dataPrincipal.split("-") : null;
      var newData =
        partesData != null
          ? new Date(partesData[0], partesData[1] - 1, partesData[2])
          : null;

      const verificarData =
        parseFloat(valorMaximo) - parseFloat(retirado) != 0
          ? parseFloat(valorMaximo) - parseFloat(retirado)
          : newData <= new Date()
          ? parseFloat(valorMaximo)
          : 0;

      row.quantidade = row.quantidade == undefined ? 0 : row.quantidade;

      // console.log(valorMaximo, retirado, verificarData, row);
      /* eslint-disable-next-line */
      if (
        parseFloat(row.quantidade) > parseFloat(verificarData) ||
        response?.data?.results[0].pode_retirar == "Não"
      ) {
        aviso.value = true;
        linha.value = props;
        props.row.loadingButton = false;
      } else {
        props.selected = !props.selected;
        props.row.loadingButton = false;
      }
      props.row.loadingButton = false;
    };

    const adicionarLinha = async (resultado) => {
      aviso.value = false;
      if (resultado) {
        linha.value.selected = !linha.value.selected;
      }
    };

    const fecharFacial = async () => {
      facial.value = false;
    };

    const receberFace = async (faceImage) => {
      imagemBase64.value = faceImage;
      facial.value = false;

      quasar.notify({
        message: "Face recebida com sucesso",
        color: "positive",
        actions: [
          {
            label: "fechar",
            color: "white",
            handler: () => {
              /* ... */
            },
          },
        ],
      });
    };

    const receberFaceCadastro = async () => {
      facial.value = false;

      quasar.notify({
        message: "Face cadastrada com sucesso! Agora você pode coletar a face.",
        color: "positive",
        actions: [
          {
            label: "fechar",
            color: "white",
            handler: () => {
              /* ... */
            },
          },
        ],
      });
    };

    const atualizarTemplatesFacial = async () => {
      try {
        if (dados.value.usuario) {
          dados.value.usuario.biometria_facial = true;
        }
      } catch (error) {
        console.log(error);
      }
    };

    const converterData = (data) => {
      let partesData = data.split("/");

      const agora = new Date();

      let dataObjeto = new Date(
        partesData[2],
        partesData[1] - 1,
        partesData[0],
        agora.getHours(),
        agora.getMinutes(),
        agora.getSeconds()
      );

      const ano = dataObjeto.getFullYear();
      const mes = (dataObjeto.getMonth() + 1).toString().padStart(2, "0");
      const dia = dataObjeto.getDate().toString().padStart(2, "0");
      const horas = dataObjeto.getHours().toString().padStart(2, "0");
      const minutos = dataObjeto.getMinutes().toString().padStart(2, "0");
      const segundos = dataObjeto.getSeconds().toString().padStart(2, "0");

      return `${ano}-${mes}-${dia}T${horas}:${minutos}:${segundos}`;
    };
    onMounted(listarContratos);
    onMounted(gerarDataAtual);

    const buscarPorCracha = async (card_id) => {
      if (!card_id || card_id.trim() === "") {
        usuarioEncontradoPorCracha.value = null;
        return;
      }

      try {
        const response = await store.dispatch("requisicao/listarFuncionarios", {
          card_id: card_id,
          vendor_id: unidade.value?.id,
        });

        if (response.data?.results?.data?.length > 0) {
          const usuario = response.data.results.data[0];
          usuarioEncontradoPorCracha.value = usuario;

          const funcionarioFormatado = {
            id: usuario.sap,
            idTabela: usuario.id,
            nome: usuario.name,
            matricula: usuario.sap,
            centroCustoCode: usuario.cost_center?.code,
            centroCustoName: usuario.cost_center?.name,
            biometria: usuario.biometry,
          };

          receberFuncionario(funcionarioFormatado);
        } else {
          usuarioEncontradoPorCracha.value = null;
        }
      } catch (error) {
        console.error("Erro ao buscar usuário por crachá:", error);
        usuarioEncontradoPorCracha.value = null;
      }
    };

    const temPermissaoCracha = () => {
      return (
        store.state.autenticacao?.usuarioLogado?.permissoes?.gmapi?.roles?.includes(
          "voucher-auth-cracha"
        ) || false
      );
    };

    // Configurar manipuladores de clique para abrir imagens em tamanho grande
    onMounted(() => {
      // Adicionar listener para todas as imagens de produtos na tabela
      const configurarCliqueDasImagens = () => {
        const imagens = document.querySelectorAll(
          ".img-container-grid, .img-container"
        );
        imagens.forEach((elem) => {
          elem.addEventListener("click", () => {
            // Obter a URL da imagem se ela existir
            const imgElement = elem.querySelector("img");
            if (imgElement && imgElement.src) {
              abrirImagemAmpliada(imgElement.src);
            }
          });

          // Adicionar classe de cursor para mostrar que é clicável
          elem.classList.add("imagem-clicavel");
        });
      };

      // Configurar inicialmente e sempre que a lista de produtos mudar
      configurarCliqueDasImagens();

      // Configurar observador de mutações para detectar quando novas imagens são carregadas
      const observer = new MutationObserver(configurarCliqueDasImagens);
      observer.observe(document.body, { childList: true, subtree: true });
    });

    const temPermissaoComSaldo = computed(() => {
      return (
        store.state.autenticacao?.usuarioLogado?.permissoes?.gmapi?.roles?.includes(
          "voucher-mostrar-com-saldo"
        ) || false
      );
    });

    const temPermissaoSemSaldo = computed(() => {
      return (
        store.state.autenticacao?.usuarioLogado?.permissoes?.gmapi?.roles?.includes(
          "voucher-mostrar-sem-saldo"
        ) || false
      );
    });

    const isSaldoSelectDisabled = computed(() => {
      return temPermissaoComSaldo.value || temPermissaoSemSaldo.value;
    });

    const saldoOptionsFiltered = computed(() => {
      if (temPermissaoComSaldo.value) {
        return [{ label: "Com Saldo", value: "com-saldo" }];
      }
      if (temPermissaoSemSaldo.value) {
        return [{ label: "Sem Saldo", value: "sem-saldo" }];
      }
      return [
        { label: "Todos", value: "" },
        { label: "Com Saldo", value: "com-saldo" },
        { label: "Sem Saldo", value: "sem-saldo" },
      ];
    });

    const inicializarSaldoBasedoNasPermissoes = () => {
      if (temPermissaoComSaldo.value) {
        saldo.value = "com-saldo";
      } else if (temPermissaoSemSaldo.value) {
        saldo.value = "sem-saldo";
      } else {
        // Mantem a lógica original para usuarios sem permissoes especificas
        saldo.value =
          store.state.autenticacao.cliente.includes("acciona") ||
          store.state.autenticacao.cliente.includes("staging-acciona")
            ? "com-saldo"
            : "";
      }
    };

    const temPermissaoBuscaCA = () => {
      return (
        store.state.autenticacao?.usuarioLogado?.permissoes?.gmapi?.roles?.includes(
          "voucher-busca-ca"
        ) || false
      );
    };

    return {
      columns,
      columns2,
      unidade,
      receberFuncionario,
      receberFuncionarioPorCracha,
      listarContratos,
      columnsLiberados,
      compararDataCritico,
      dados,
      lotes,
      botaoRequisicaoTravar,
      listaContratosOptions,
      selecionarContrato,
      listarUsuarios,
      filtros,
      listaUsuarios,
      loadingInner,
      listarProdutos,
      listaProdutos,
      selected,
      removerProduto,
      adicionarLinha,
      verificarQuantidadeHttp,
      listarProdutosLiberados,
      criarRequisicao,
      autenticacao,
      adicionarLote,
      detalharRequisicao,
      gerarDataAtual,
      pin,
      biometria,
      atualizarTemplatesBiometria,
      checarPin,
      imagemBase64,
      recebeBiometria,
      mobile,
      finalizarRequisicao,
      loading,
      listarTodos,
      receberResultadoBiometria,
      usuarioVerificado,
      atualizarUsuario,
      userLogado,
      recebeAssinatura,
      salvarAssinatura,
      gerarTimestamp,
      atualDate,
      item,
      atualizarHistorico,
      quasar,
      compararData,
      verificarQuantidade,
      aviso,
      facial,
      fecharFacial,
      centroCustoUsuario,
      receberFace,
      receberFaceCadastro,
      atualizarTemplatesFacial,
      saldo,
      crachaSolicitante,
      usuarioEncontradoPorCracha,
      solicitanteMatricula,
      solicitantePesquisa,
      buscarPorCracha,
      temPermissaoCracha,
      // Controle de intercepção da mudança de tipo de requisição
      interceptarMudancaTipoRequisicao,
      // Controle da imagem ampliada
      imagemAmpliada,
      imagemUrl,
      abrirImagemAmpliada,
      // Validação de CA
      isValidationModalOpen,
      selectedCaNumber,
      selectedCaId,
      validarCa,
      handleCaUpdated,
      myLocale: {
        days: "Domingo_Segunda_Terça_Quarta_Quinta_Sexta_Sábado".split("_"),
        daysShort: "Dom_Seg_Ter_Quar_Quin_Sex_Sáb".split("_"),
        months:
          "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split(
            "_"
          ),
        monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split(
          "_"
        ),
        firstDayOfWeek: 1,
      },
      optionsFn(date) {
        var hoje = new Date();

        var ontem = new Date(hoje.getTime());
        ontem.setDate(hoje.getDate());

        var dd = ontem.getDate();
        var mm = ontem.getMonth() + 1;
        var yyyy = ontem.getFullYear();

        if (dd < 10) {
          dd = "0" + dd;
        }

        if (mm < 10) {
          mm = "0" + mm;
        }

        var data_ok = yyyy + "/" + mm + "/" + dd;

        return date <= data_ok;
      },
      saldoOptions: [
        { label: "Todos", value: "" },
        { label: "Com Saldo", value: "com-saldo" },
        { label: "Sem Saldo", value: "sem-saldo" },
      ],
      saldoOptionsFiltered,
      isSaldoSelectDisabled,
      filterFn(val, update) {
        listarUsuarios(val);
        setTimeout(() => {
          update();
        }, 300);
      },
      temPermissaoBuscaCA,
      dataRetroativaErro,
      validateDataRetroativa,
    };
  },
};
</script>

<style scoped>
.q-table__top,
thead tr:first-child th {
  background-color: #eef3fe;
}

thead tr th {
  position: sticky;
  z-index: 1;
}
thead tr:first-child th {
  top: 0;
}

.q-table--loading thead tr:last-child th {
  top: 48px;
}
.my-sticky-dynamic {
  max-height: 400px;
}
thead tr th {
  position: sticky;
  z-index: 1;
}
thead tr:last-child th {
  top: 48px;
}
thead tr:first-child th {
  top: 0;
}
.texto-titulo-tabela {
  font-size: 18px;
}
.texto-autenticacao {
  font-size: 18px;
}
.imagem-biometria {
  height: 80px;
  width: 80px;
  cursor: pointer;
}
.radio-input {
  width: 24%;
}
.mobile {
  display: none;
}
.texto-link {
  font-size: 19px;
  margin-bottom: 4px;
  font-weight: bold;
}
.video {
  height: 300px;
  width: 450px;
}
.texto-link-legenda {
  font-size: 16px;
}
.texto-toggle {
  font-size: 14px;
}
.elipse {
  width: 12px;
  height: 12px;
  border-radius: 50%;
}

@media only screen and (max-width: 768px) {
  .text-h6 {
    font-size: 1.2rem !important;
    text-align: center;
  }

  .container-inputs {
    flex-direction: column !important;
    gap: 0 !important;
    margin: 0;
  }

  .col-md,
  .col-md-2 {
    width: 100% !important;
    flex: 0 0 100% !important;
    max-width: 100% !important;
    margin-bottom: 16px;
  }

  .container-radio {
    width: 100% !important;
    margin-top: 20px;
    padding: 0;
  }

  .radio-input-tipo {
    flex-direction: column !important;
  }

  .radio-input-tipo .q-radio {
    margin-bottom: 12px;
  }

  .texto-titulo-input,
  .texto-titulo-select {
    font-size: 12px !important;
    margin-bottom: 4px;
  }

  .titulo-input-tipo-requisicao {
    font-size: 14px !important;
  }

  .input-new-design {
    margin-bottom: 16px;
  }

  .q-page {
    padding: 12px !important;
  }

  .container-autenticacao {
    flex-direction: column !important;
  }

  .container-autenticacao .q-radio {
    margin-bottom: 12px;
  }

  .container-autenticacao-pin {
    flex-direction: column !important;
    align-items: flex-start !important;
  }

  .container-btn {
    justify-content: center !important;
    margin-top: 20px;
  }

  .video {
    height: 200px !important;
    width: 100% !important;
  }

  .texto-link {
    font-size: 16px !important;
  }

  .sem-margin {
    margin-left: 0 !important;
  }
}

@media only screen and (max-width: 390px) {
  .text-h6 {
    font-size: 1.1rem !important;
  }

  .titulo-input-tipo-requisicao {
    font-size: 13px !important;
  }

  .q-page {
    padding: 8px !important;
  }

  .video {
    height: 180px !important;
  }
}

@media (max-width: 600px) {
  .desktop {
    display: none;
  }
  .mobile {
    display: block;
  }

  .data-retirada-container {
    max-width: 70% !important;
    width: 70% !important;
  }

  .data-retirada-container .q-field {
    width: 70% !important;
  }

  .my-sticky-dynamic {
    max-height: 1000px;
  }
  .text-grid-table {
    font-size: 12px;
  }
  .card {
    border: 1px solid #a8b3c9;
    border-radius: 10px;
    margin-bottom: 10px;
  }
  .texto-titulo {
    font-size: 12px;
  }
  .container-inputs {
    margin-top: 20px;
    margin-left: 0;
  }

  .texto-titulo-input {
    font-size: 12px;
  }
  .canvas-container {
    overflow-x: scroll;
  }
  .input {
    font-size: 12px;
  }
  .select {
    font-size: 12px;
  }
  .container-radio {
    font-size: 12px;
    margin-top: 10px;
  }
  .texto-titulo-tabela {
    font-size: 14px;
  }
  .radio-input {
    width: 100%;
    margin-bottom: 10px;
  }
  .radio-input-tipo {
    margin-top: 5px;
  }
  .texto-alerta {
    font-size: 12px;
    text-align: center;
  }
  .container-btn {
    margin-top: 10px;
    align-items: center;
    justify-content: center;
  }
  .texto-autenticacao {
    font-size: 12px;
  }
  .container-autenticacao {
    margin-top: 5px;
  }
  .input-grid {
    width: 100%;
  }
  .img-container-grid {
    width: 50px;
    height: 50px;
  }
  .img-grid {
    width: 50px;
    height: 50px;
  }
  .img-container {
    width: 50px;
    height: 50px;
  }
  .input-quantidade {
    font-size: 12px;
  }
  .input-quantidade-container {
    width: 50px;
  }
  .titulo-input-unidade {
    font-size: 12px;
  }
  .titulo-input-tipo-requisicao {
    font-size: 12px;
  }
  .arrow {
    font-size: 20px;
    border-radius: 50%;
    padding: 5px;
    cursor: pointer;
    margin: 0px 3px 0px 3px;
    color: white;
  }
  .container-video {
    margin-top: 10px;
  }
  .texto-link {
    font-size: 12px;
  }
  .video {
    height: 150px;
    width: 100%;
  }

  .sem-margin {
    margin-left: 0;
  }
  .texto-link-legenda {
    font-size: 12px;
  }
  @media only screen and (max-width: 368px) {
    .input-quantidade-container {
      width: 40px;
    }
  }
}
</style>
<style>
.input-new-design .q-field--outlined .q-field__control {
  border-radius: 8px !important;
}

.input-new-design .q-field__control:before {
  border-radius: 8px !important;
}

.imagem-ampliada-container {
  background-color: rgba(0, 0, 0, 0.9);
  width: 100%;
  height: 100%;
  cursor: pointer;
}

.imagem-ampliada {
  max-width: 90vw;
  max-height: 80vh;
}

.botao-fechar {
  position: absolute;
  top: 10px;
  right: 10px;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 10;
  font-size: 1.5rem;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  transition: transform 0.2s;
}

.botao-fechar:hover {
  transform: scale(1.1);
  background-color: rgba(0, 0, 0, 0.7);
}

.imagem-clicavel {
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
}

.imagem-clicavel:hover {
  transform: scale(1.05);
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.3);
}

.imagem-clicavel::after {
  content: "";
  position: absolute;
  bottom: 3px;
  right: 3px;
  width: 16px;
  height: 16px;
  background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white"><path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 5 1.5-1.5-5-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/><path d="M12 10h3v1h-3v3h-1v-3H8v-1h3V7h1z"/></svg>');
  background-size: cover;
  border-radius: 50%;
  background-color: rgba(25, 118, 210, 0.7);
}
</style>
